import { useQuery } from '@tanstack/react-query';

import { useFleet, useHasPermission } from '../hooks';
import { ModelOption } from '../interfaces';
import { ModelRegistryService } from '../services';
import { isNotProd } from '../utils';

export const useModelRegistry = () => {
  const fleet = useFleet();
  const hasPermission = useHasPermission('ota:read:list');

  return useQuery<ModelOption[]>({
    queryKey: ['modelRegistry', fleet.id],
    queryFn: () => ModelRegistryService.getModels(),
    enabled: hasPermission && !!fleet.id && isNotProd(),
  });
};
